<!-- @format -->

<template>
<div class="login-page">
    <app-navbar></app-navbar>
    <div class="wrapper wrapper-full-page">
        <div class="full-page login-page section-image">
            <!--   you can change the color of the filter page using: data-color="blue | azure | green | orange | red | purple" -->
            <div class="content">
                <FlashMessage :position="'right top'"></FlashMessage>
                <div class="container">
                    <div class="header-body text-center" style="margin-bottom: 15px;">
                        <div class="row justify-content-center"></div>
                    </div>
                    <div class="col-lg-4 col-md-6 ml-auto mr-auto">
                        <form @submit.prevent="login">
                            <card type="login">
                                <h3 slot="header" class="header text-center">Admin Login</h3>
                                <input v-model.trim="$v.user.number.$model" addon-left-icon="nc-icon nc-single-02" class="form-control abc" placeholder="Enter mobile number" @keypress="onlyNumber" maxlength="10" />
                                <div class="error" v-if="submitted && !$v.user.number.required">Please enter mobile number</div>
                                <div class="error" v-if="submitted && !$v.user.number.minLength">Please enter valid number </div>
                                <div class="error" v-if="submitted && !$v.user.number.maxLength">Please enter valid number </div>
                                <br>
                                <input v-model="$v.user.password.$model" addon-left-icon="nc-icon nc-key-25" class="form-control" placeholder="Enter password" type="password" />
                                <div class="error" v-if="submitted && !$v.user.password.required">Please enter password</div>

                                <div slot="footer">
                                    <p-button native-type="submit" slot="footer" type="warning" round block class="mb-3">Login</p-button>

                                    <div class="pull-left">
                                        <h6>
                                            <a href="/password/reset" class="link footer-link">Forgot Password?</a>
                                        </h6>
                                    </div>
                                </div>
                            </card>
                        </form>
                    </div>
                </div>
            </div>
            <app-footer></app-footer>
            <div class="full-page-background" style="background-image: url(/static/img/background/furniture.jpg) "></div>
        </div>
    </div>
</div>
</template>

<script>
import {
    Card,
    Button
} from "src/components/UIComponents";
import AppNavbar from "./Layout/AppNavbar";
import AppFooter from "./Layout/AppFooter";
import formMixin from "@/mixins/form-mixin";
import ValidationError from "src/components/UIComponents/ValidationError.vue";
import {
    required,
    minLength,
    maxLength,
    between,
} from "vuelidate/lib/validators";
import Auth from "src/Auth.js";

export default {
    mixins: [formMixin],
    components: {
        Card,
        AppNavbar,
        AppFooter,
        [Button.name]: Button,
        ValidationError,
    },
    data() {
        return {
            submitted: false,
            user: {
                number: "",
                password: "",

            },
        };
    },
    validations: {
        user: {
            number: {
                required,
                minLength: minLength(10),
                maxLength: maxLength(10),
            },
            password: {
                required,
            },
        }
    },
    methods: {
        onlyNumber($event) {
            //console.log($event.keyCode); //keyCodes value
            let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
            if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) { // 46 is dot
                $event.preventDefault();
            }
        },

        toggleNavbar() {
            document.body.classList.toggle("nav-open");
        },
        closeMenu() {
            document.body.classList.remove("nav-open");
            document.body.classList.remove("off-canvas-sidebar");
        },
        login() {

            this.submitted = true;
            this.$v.$touch()
            if (this.$v.$invalid) {
                return;
            } else {
                
                this.axios
                    .post(`${process.env.VUE_APP_API_BASE_URL}/api/login`, this.user)
                    .then(({data}) => {
                        this.flashMessage.success({
                            message: 'Login Successful'
                        });
                        Auth.login(data.access_token, data.user); //set local storage
                        this.$router.push("/");
                        
                    })
                .catch((error) => {
                    // console.log(error.response.data.error)
                    this.flashMessage.error({
                            // message: 'Invalid Credentials'
                            message: error.response.data.error

                        });

                });
            }
        },
    },
    beforeDestroy() {
        this.closeMenu();
    },

};
</script>

<style></style>
